<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-c2">
    <p>
      <strong>{{ 'password.recovery.method.email.title' | translate }}</strong>
    </p>
    <p class="rs-padding-bottom1">
      {{ 'password.recovery.method.email.pending.description' | translate }}
    </p>
    <div class="rs-flex-row rs-flex-collapse rs-flex-middle" *ngIf="!showChangeEmailId">
      <div class="rs-flex-columns small-9">
        <p>
          <strong class="rs-word-break-all">{{ pendingMailId }}</strong>
        </p>
      </div>
      <div class="rs-flex-columns small-3">
        <p class="text-right">
          <button
            (click)="showChangeEmailId = !showChangeEmailId"
            class="rs-link-action rs-link-action-edit"
          >
            <span class="rs-link-action-label show-for-medium-up" aria-hidden="true">{{
              'password.recovery.method.email.pending.edit' | translate
            }}</span
            ><span class="rs-action-link-icon"></span>
          </button>
        </p>
      </div>
    </div>
    <p class="text-center medium-text-left" *ngIf="!showChangeEmailId">
      <button class="rs-link-action rs-link-action-mail" (click)="setEmailRecovery()">
        <span class="rs-link-action-label" aria-hidden="true">{{
          'password.recovery.method.email.pending.resend.title' | translate
        }}</span
        ><span class="rs-action-link-icon"></span>
      </button>
    </p>
    <span *ngIf="showChangeEmailId">
      <mprd-email-submit
        (validEmailSubmit)="onValidEmailSubmit($event)"
        (emailSubmitCancel)="onEmailSubmitCancel()"
        *ngIf="showChangeEmailId"
      ></mprd-email-submit>
    </span>
  </div>
</div>
